import React from 'react';
import PropTypes from 'prop-types';
import {
  TabContent,
  TabPane,
} from 'reactstrap';

import AdminTaxonomyEditMainEdit from './MainEdit';
import AdminTaxonomyEditSettings from './Settings';
import AdminTaxonomyEditMetadataGroups from './MetadataGroups';

const AdminTaxonomyEditTabContent = ({ activeTab, ...props }) => (
  <TabContent activeTab={activeTab} className="settings-tab-content taxonomy-edit">
    <TabPane tabId="details">
      <AdminTaxonomyEditMainEdit
        {...props}
      />
    </TabPane>
    <TabPane tabId="settings">
      <AdminTaxonomyEditSettings
        {...props}
        entity={props.taxonomy}
        entityId={props.taxonomyId}
      />
    </TabPane>
    <TabPane tabId="metadata-groups">
      <AdminTaxonomyEditMetadataGroups
        {...props}
        entity={props.taxonomy}
        entityId={props.taxonomyId}
      />
    </TabPane>
  </TabContent>
);

AdminTaxonomyEditTabContent.propTypes = {
  taxonomy: PropTypes.object,
  taxonomyId: PropTypes.string,
  activeTab: PropTypes.string.isRequired,
};

AdminTaxonomyEditTabContent.defaultProps = {
  taxonomy: null,
  taxonomyId: null,
};

export default AdminTaxonomyEditTabContent;
